<template>
  <div class="modal fade" id="podftAsideModal" tabindex="-1" aria-labelledby="podftAsideModal" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 v-if="item" class="modal-title" id="clientModalLabel">
            <span v-if="item.entity === 0">{{item.item.client.title ?? item.item.document.number}}</span>
            <span v-else>{{item.item.color+' '+item.item.mark+' '+item.item.model}}</span>
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <div class="row" v-if="item">
            <div class="col-lg-8">
              <div class="rounded">
                <VueMagnifier class="rounded" :src="item.front_image" zoomFactor="1.8"/>
                <hr class="text-gray-400">
                <VueMagnifier class="rounded" :src="item.back_image" zoomFactor="1.8"/>
              </div>
            </div>
            <div class="col-lg-4" style="border-left: 1px solid #efefef;">
              <podft-aside-modal-solution :item="item" :solution="solution" @setPodft="setPodft"/>
              <podft-aside-modal-appeal   :item="item"/>
              <podft-aside-modal-client   v-if="item.entity === 0" :item="item"/>
              <podft-aside-modal-vehicle  v-else :item="item"/>
              <podft-aside-modal-history  v-if="history && history.length > 1" :lists="history" :this-id="item.id" @getItem="getHistoryItem"/>
            </div>
          </div>
        </div>
        <div class="modal-footer p-2 justify-content-center">
          <button
              @click="clearForm"
              type="button"
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
          >Закрыть</button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
import PodftAsideModalSolution from '@/components/Podft/PodftAsideModal/PodftAsideModalSolution.vue';
import PodftAsideModalVehicle  from '@/components/Podft/PodftAsideModal/PodftAsideModalVehicle.vue'
import PodftAsideModalClient   from '@/components/Podft/PodftAsideModal/PodftAsideModalClient.vue'
import PodftAsideModalAppeal   from '@/components/Podft/PodftAsideModal/PodftAsideModalAppeal.vue';
import VueMagnifier            from '@websitebeaver/vue-magnifier'
import LoaderFull              from '@/components/Main/LoaderFull.vue'
import axios                   from 'axios'
import PodftAsideModalHistory from "@/components/Podft/PodftAsideModal/PodftAsideModalHistory.vue";

export default {
  name: 'PodftAsideModal',
  components: {
    PodftAsideModalHistory,
    PodftAsideModalSolution,
    PodftAsideModalVehicle,
    PodftAsideModalClient,
    PodftAsideModalAppeal,
    LoaderFull,
    VueMagnifier
  },
  props: {
    itemId: null,
    itemIndex: null
  },
  data() {
    return {
      loader: true,
      item: null,
      history: null,
      solution: {
        comment: '',
        status: 3
      }
    }
  },
  methods: {
    asideClose() {
      this.$emit('close', true)
    },
    setPodft(val) {
      if (val) {
        this.loader = true
        const headers = {id:this.itemId, status:this.solution.status, comment: this.solution.comment}
        axios.post('/api/podft/set', headers)
            .then(res => {
              this.$emit('updateItem', {key: this.itemIndex, data: res.data[0]})
              const myModalEl = document.getElementById('podftAsideModal');
              const modal = bootstrap.Modal.getInstance(myModalEl);
              modal.hide();
              setTimeout(() => {this.item = null}, 100)
            })
            .catch(err => {
              console.log(err)
            })
            .finally(() => {
              this.loader = false
            })
      }
    },
    getItem(id) {
      this.loader = true
      const headers = {id:id}
      axios.post('/api/podft/item', headers)
          .then(res => {
            const data = res.data.item[0]
            this.item = data
            if (res.data.history && res.data.history.length) this.history = res.data.history
            this.solution.status = data.status === 1 ? 3 : data.status
            this.solution.comment = data.comment ?? ''
          })
          .catch(err => {console.log(err)})
          .finally(() => this.loader = false)
    },
    getHistoryItem(val) {
      this.getItem(val)
    }
  },
  watch: {
    itemId: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.getItem(this.itemId)
        } else {
          this.loader = false
          this.item   = null
        }
      }
    }
  }
}
</script>

<style scoped>
@import '@websitebeaver/vue-magnifier/styles.css';
</style>